import { render } from "./support.en-US.vue?vue&type=template&id=fb33f076"
const script = {}

import "./support.en-US.vue?vue&type=style&index=0&id=fb33f076&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__